module.exports = __webpack_public_path__ + "static/media/YF75_01.d04992bc.jpg";